import React, { useEffect, useState } from 'react';
import { tasksService } from '../services/tasksService';
import { toast } from '../utils/toast';
import PullToRefresh from '../components/PullToRefresh';
import syncService from '../services/syncService';
import { getPriorityLabel, getPriorityIcon } from '../utils/translations';
import './IncompleteTasks.css';

const IncompleteTasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [completingId, setCompletingId] = useState(null);

  const loadTasks = async () => {
    try {
      const response = await tasksService.getIncomplete();
      const data = Array.isArray(response) ? response : response?.data;
      setTasks(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error loading incomplete tasks:', error);
      toast.error('Ошибка загрузки задач');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadTasks(); }, []);

  const handleRefresh = async () => {
    await syncService.syncAll();
    await loadTasks();
  };

  const handleComplete = async (task) => {
    setCompletingId(task.id);
    try {
      const response = await tasksService.complete(task.id);
      const data = response?.data || response || {};
      const due = Number(data.amount_due || task.cost || 0);
      toast.success(`${data.message || 'Задача завершена'}${due > 0 ? ` К оплате: ${due} ₽` : ''}`);
      setTasks(current => current.filter(item => item.id !== task.id));
    } catch (error) {
      toast.error(error.response?.data?.error || 'Ошибка при завершении задачи');
    } finally {
      setCompletingId(null);
    }
  };

  if (loading) return <div className="spinner" />;

  return (
    <PullToRefresh onRefresh={handleRefresh} disabled={loading}>
      <div className="incomplete-tasks">
        <div className="page-header">
          <h1>Невыполненные задачи</h1>
          <button onClick={loadTasks} className="btn btn-secondary" disabled={loading}>Обновить</button>
        </div>
        <p className="subtitle">После завершения платная задача попадёт в список «Завершено, не оплачено».</p>
        {tasks.length === 0 ? (
          <div className="empty-state"><p>Все задачи выполнены.</p></div>
        ) : (
          <div className="tasks-grid">
            {tasks.map(task => (
              <div key={task.id} className="task-card" style={{ borderLeftColor: task.color || '#4CAF50' }}>
                <div className="task-header">
                  <h3>{task.title}</h3>
                  <span className={`priority-badge ${task.priority}`}>{getPriorityIcon(task.priority)} {getPriorityLabel(task.priority)}</span>
                </div>
                {task.description && <p className="task-description">{task.description}</p>}
                {task.client_name && <p>Клиент: {task.client_name}</p>}
                {task.due_date && <p>Срок: {new Date(task.due_date).toLocaleDateString('ru-RU')}</p>}
                {Number(task.cost || 0) > 0 && <p>Стоимость: {Number(task.cost).toLocaleString('ru-RU')} ₽</p>}
                <button onClick={() => handleComplete(task)} disabled={completingId === task.id} className="btn btn-primary complete-btn">
                  {completingId === task.id ? 'Завершение…' : 'Завершить задачу'}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </PullToRefresh>
  );
};

export default IncompleteTasks;
